var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountBadgeEntityName, logBadgeHistoryActionFunctionDef, } from '../../../../backend/features/badges/shared';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
/**
 * Utility to combine `accountBadge` update and `badgeHistoryEntityName` insert
 *
 * Use this instead of manual `accountBadgeStorageClient.post() + logBadgeHistoryAction()`
 */
export function useUpdateAccountBadgeWithHistory(badgeId) {
    const accountBadgeStorageClient = useStorageClient(accountBadgeEntityName);
    const logBadgeHistoryAction = useTypedPlatformFunction(logBadgeHistoryActionFunctionDef);
    return {
        updateAccountWithHistory: (accountBadgeId, data, history) => __awaiter(this, void 0, void 0, function* () {
            if (!accountBadgeId || !badgeId) {
                return;
            }
            yield accountBadgeStorageClient.post({
                action: 'partial-update',
                id: accountBadgeId,
                data,
            });
            yield logBadgeHistoryAction(Object.assign({ badgeId, accountBadgeIds: [accountBadgeId] }, history));
        }),
    };
}
